import { render } from "./Send.vue.js?vue&type=template&id=f700e410!=!../vue-loader/dist/index.js??ruleSet[0]!./Send.vue?vue&type=template&id=f700e410"
import script from "./Send.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Send.vue?vue&type=script&lang=js"
export * from "./Send.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Send.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__